module.exports = __webpack_public_path__ + "img/python_test_output_interception.b329a823.png";